import { useCallback, useMemo } from 'react';
import { UnifiedAuthView } from './UnifiedAccountView';
import { UnifiedHeadlessAuthView } from './UnifiedHeadlessAuthView';
import { createAuthConfigFetchers } from './helpers/createAuthConfigFetcher';
import { deleteAccount } from './api/UnifiedAccountApi';
import { jsx as _jsx } from "react/jsx-runtime";
export function UnifiedAccountModal({
  inline = false,
  portalId,
  appId,
  appName,
  oAuthScope,
  oAuthScopes,
  accountId,
  mcpParams,
  oAuthorMigrationParams,
  incremental,
  mode,
  onComplete,
  onCancel,
  onAuthError,
  config
}) {
  const {
    shouldDeleteOnFailure,
    useIntroScreen,
    useSuccessScreen
  } = config !== null && config !== void 0 ? config : {};

  // Serialised to a string to avoid array reference instability in the dep array
  const oAuthScopesCacheKey = oAuthScopes === null || oAuthScopes === void 0 ? void 0 : oAuthScopes.join('\0');
  const fetchers = useMemo(() => createAuthConfigFetchers({
    portalId,
    appId,
    appName,
    oAuthScope,
    oAuthScopes,
    mcpParams: mcpParams !== null && mcpParams !== void 0 ? mcpParams : undefined,
    incremental
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [portalId, appId, appName, oAuthScope, oAuthScopesCacheKey, mcpParams, incremental]);
  const handleComplete = useCallback(({
    accountId: newAccountId
  }) => {
    try {
      onComplete(newAccountId);
    } catch (error) {
      console.error('Failed to complete account creation:', error);
      const shouldCleanup = shouldDeleteOnFailure ? shouldDeleteOnFailure(newAccountId) : true;
      if (shouldCleanup) {
        void deleteAccount(newAccountId);
      }
      throw error;
    }
  }, [onComplete, shouldDeleteOnFailure]);
  const isMigrationReconnect = !!oAuthorMigrationParams;
  const isReauth = !isMigrationReconnect && !!accountId;
  const fetchAuthConfig = isMigrationReconnect ? () => fetchers.forMigrationReconnect(oAuthorMigrationParams === null || oAuthorMigrationParams === void 0 ? void 0 : oAuthorMigrationParams.oAuthorAccountId) : isReauth ? () => fetchers.forReconnect(accountId) : fetchers.forNewAccount;
  if (mode === 'headless') {
    return /*#__PURE__*/_jsx(UnifiedHeadlessAuthView, {
      portalId: portalId,
      appName: appName,
      isReauth: isMigrationReconnect || isReauth,
      accountId: isReauth ? accountId : undefined,
      onComplete: handleComplete,
      onCancel: onCancel,
      onAuthError: onAuthError,
      useIntroScreen: useIntroScreen,
      useSuccessScreen: useSuccessScreen,
      fetchAuthConfig: fetchAuthConfig
    });
  }
  return /*#__PURE__*/_jsx(UnifiedAuthView, {
    isModal: !inline,
    isReauth: isMigrationReconnect || isReauth,
    portalId: portalId,
    accountId: isReauth ? accountId : undefined,
    appName: appName,
    onComplete: handleComplete,
    onCancel: onCancel,
    useIntroScreen: useIntroScreen,
    useSuccessScreen: useSuccessScreen,
    onAuthError: onAuthError,
    fetchAuthConfig: fetchAuthConfig
  });
}
export default UnifiedAccountModal;